import { useQuery } from '@tanstack/react-query';
import { getFeed } from 'src/service/engageFrontendGateway';
import { FeedItem, FeedSort, FeedSortDirection, FeedType } from 'types/feeds';

export const useFeed = (
  initialFeed: FeedItem[] | undefined,
  pageId: string,
  feedType: FeedType,
  options: {
    locale: string;
    organization?: string;
    sort?: FeedSort;
    sortDirection?: FeedSortDirection;
    includeClosed?: boolean;
    // Block-scoped key: two same-feedType blocks on a page can have different priority pins,
    // so contentId must be part of the query key to avoid aliasing in the client cache.
    contentId?: string;
  },
) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['feed', pageId, feedType, options.locale, options.contentId, options],
    queryFn: () => getFeed(pageId, feedType, options),
    initialData: initialFeed,
  });

  return {
    feed: data || [],
    isLoadingFeed: isLoading,
    feedError: error,
  };
};
